import { useQuery } from "@apollo/client";
import { GET_PERSONAL_BANK_ACCOUNT } from "graphql/account";
import AccountType from "enums/AccountType";
import { BankAccount } from "./useGetBankAccounts";

interface UseGetPersonalBankAccountParams {
  skip?: boolean;
}

const useGetPersonalBankAccount = ({
  skip = false,
}: UseGetPersonalBankAccountParams = {}) => {
  const { data, loading, refetch } = useQuery(GET_PERSONAL_BANK_ACCOUNT, {
    skip: skip,
    fetchPolicy: "cache-and-network",
  });

  // Map personal bank account to BankAccount format
  const personalBankAccount: BankAccount | null = data?.personalBankAccount
    ? {
        id: data.personalBankAccount.id,
        accountId: data.personalBankAccount.key,
        bankName: data.personalBankAccount.name,
        last4: data.personalBankAccount.last4,
        status: data.personalBankAccount.status,
        accountType: AccountType.PERSONAL_BANK,
        microDepositUrl: data.personalBankAccount.microDepositUrl,
      }
    : null;

  const bankAccountsArray: BankAccount[] = personalBankAccount
    ? [personalBankAccount]
    : [];

  return {
    personalBankAccount,
    bankAccountsArray,
    loading,
    refetch,
  };
};

export default useGetPersonalBankAccount;
